import React, { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import "../index.css";

const ProtectedRoutes = () => {
  const navigate = useNavigate();
  const { lang } = useParams();
  const userLoggedIn = localStorage.getItem("userLoggedIn");

  useEffect(() => {
    if (!userLoggedIn) {
      navigate(`/${lang}/login`);
    }
  }, [userLoggedIn, navigate, lang]);

  return <Outlet />;
};

export default ProtectedRoutes;
